import { render, staticRenderFns } from "./IncCopyright.vue?vue&type=template&id=3b4c8493"
import script from "./IncCopyright.vue?vue&type=script&lang=js"
export * from "./IncCopyright.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports